import { render, staticRenderFns } from "./no-contract.vue?vue&type=template&id=038b65c4&scoped=true&"
import script from "./no-contract.vue?vue&type=script&lang=js&"
export * from "./no-contract.vue?vue&type=script&lang=js&"
import style0 from "./no-contract.vue?vue&type=style&index=0&id=038b65c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b65c4",
  null
  
)

component.options.__file = "no-contract.vue"
export default component.exports